<div class="custom-software-page">
  <section class="main-section py-5">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-lg-10 col-12">
          <div class="main-content text-center animate-on-scroll">
            <h1 class="main-title">
              WHY CHOOSE 
              <span class="brand-name-fancy">QUADPROSOL</span>
              <span class="question-mark">?</span>
            </h1>
            <p class="main-description">{{ pageData.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="features-section py-5">
    <div class="container">
      <div class="row g-4">
        <div 
          class="col-lg-3 col-md-6 col-12" 
          *ngFor="let feature of features; let i = index"
        >
          <div 
            class="feature-card animate-on-scroll h-100"
            [style.transition-delay]="(i * 0.2) + 's'"
          >
            <div class="feature-icon-wrapper mb-4">
              <i class="feature-icon" [class]="feature.iconClass"></i>
            </div>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">{{ feature.description }}</p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="process-section py-5">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-lg-10 col-12">
          <div class="process-header text-center animate-on-scroll">
            <h2 class="process-section-title">{{ processData.title }}</h2>
            <p class="process-section-description">{{ processData.description }}</p>
          </div>
        </div>
      </div>

      <div class="row g-5">
        <div 
          class="col-12" 
          *ngFor="let step of processSteps; let i = index"
        >
          <div class="process-item animate-on-scroll" [style.transition-delay]="(i * 0.2) + 's'">
            <div class="row align-items-center g-4" [class.flex-row-reverse]="i % 2 === 1">
              <div class="col-lg-6 col-md-6 col-12">
                <div class="process-image">
                  <img 
                    [src]="step.image" 
                    [alt]="step.title"
                    loading="lazy"
                    class="img-fluid rounded-3"
                  />
                </div>
              </div>
              <div class="col-lg-6 col-md-6 col-12">
                <div class="process-content">
                  <h3 class="process-title">{{ step.title }}</h3>
                  <p class="process-description">{{ step.description }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="faq-section py-5">
    <div class="container">
      <div class="row justify-content-center mb-5">
        <div class="col-lg-8 col-12">
          <div class="faq-header text-center animate-on-scroll">
            <h2 class="faq-title">{{ faqData.title }}</h2>
            <p class="faq-subtitle">{{ faqData.subtitle }}</p>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-lg-10 col-12">
          <div class="faq-list">
            <div 
              class="faq-item animate-on-scroll"
              *ngFor="let faq of faqs; let i = index"
              [style.transition-delay]="(i * 0.1) + 's'"
            >
              <div 
                class="faq-question"
                (click)="toggleFaq(faq.id)"
                [class.expanded]="isFaqExpanded(faq.id)"
              >
                <h3 class="faq-question-text">{{ faq.question }}</h3>
                <div class="faq-toggle-icon">
                  <i class="bi bi-chevron-down" [class.rotated]="isFaqExpanded(faq.id)"></i>
                </div>
              </div>
              <div 
                class="faq-answer"
                [class.expanded]="isFaqExpanded(faq.id)"
              >
                <div class="faq-answer-content">
                  <p>{{ faq.answer }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="cta-section py-5">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-lg-8 col-12">
          <div class="cta-content text-center animate-on-scroll">
            <button 
              class="btn cta-button"
              (click)="navigateToIntake()"
              aria-label="Navigate to intake form"
            >
              {{ pageData.ctaText }}
              <i class="ms-2" [class]="pageData.ctaIcon"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>